var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 20.1172H19.1406C19.68 20.1172 20.1172 19.68 20.1172 19.1406C20.1172 18.6013 19.68 18.1641 19.1406 18.1641H12.9883C12.4489 18.1641 12.0117 18.6013 12.0117 19.1406C12.0117 19.68 12.4489 20.1172 12.9883 20.1172Z",
    fill: "url(#paint0_linear_317_3170)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 25.9766H19.1406C19.68 25.9766 20.1172 25.5394 20.1172 25C20.1172 24.4606 19.68 24.0234 19.1406 24.0234H12.9883C12.4489 24.0234 12.0117 24.4606 12.0117 25C12.0117 25.5394 12.4489 25.9766 12.9883 25.9766Z",
    fill: "url(#paint1_linear_317_3170)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 31.8359H19.1406C19.68 31.8359 20.1172 31.3987 20.1172 30.8594C20.1172 30.32 19.68 29.8828 19.1406 29.8828H12.9883C12.4489 29.8828 12.0117 30.32 12.0117 30.8594C12.0117 31.3987 12.4489 31.8359 12.9883 31.8359Z",
    fill: "url(#paint2_linear_317_3170)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0117 18.1641H30.8594C30.32 18.1641 29.8828 18.6013 29.8828 19.1406C29.8828 19.68 30.32 20.1172 30.8594 20.1172H37.0117C37.5511 20.1172 37.9883 19.68 37.9883 19.1406C37.9883 18.6013 37.5511 18.1641 37.0117 18.1641Z",
    fill: "url(#paint3_linear_317_3170)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0117 24.0234H30.8594C30.32 24.0234 29.8828 24.4606 29.8828 25C29.8828 25.5394 30.32 25.9766 30.8594 25.9766H37.0117C37.5511 25.9766 37.9883 25.5394 37.9883 25C37.9883 24.4606 37.5511 24.0234 37.0117 24.0234Z",
    fill: "url(#paint4_linear_317_3170)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0117 43.5547C37.5511 43.5547 37.9883 43.1175 37.9883 42.5781C37.9883 42.0388 37.5511 41.6016 37.0117 41.6016C36.4724 41.6016 36.0352 42.0388 36.0352 42.5781C36.0352 43.1175 36.4724 43.5547 37.0117 43.5547Z",
    fill: "url(#paint5_linear_317_3170)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0234 9.375H43.8477V7.42188C43.8477 6.88252 43.4104 6.44531 42.8711 6.44531H32.0732C29.4551 6.44531 26.9769 7.35537 25 9.02588C23.023 7.35537 20.5449 6.44531 17.9268 6.44531H7.12891C6.58955 6.44531 6.15234 6.88252 6.15234 7.42188V9.375H0.976562C0.437207 9.375 0 9.81221 0 10.3516V42.5781C0 43.1175 0.437207 43.5547 0.976562 43.5547H32.6172C33.1565 43.5547 33.5938 43.1175 33.5938 42.5781C33.5938 42.0388 33.1565 41.6016 32.6172 41.6016H25.9766V40.0649C27.6448 38.5338 29.7945 37.6953 32.0732 37.6953H42.8711C43.4104 37.6953 43.8477 37.2581 43.8477 36.7188V11.3281H48.0469V41.6016H41.4062C40.8669 41.6016 40.4297 42.0388 40.4297 42.5781C40.4297 43.1175 40.8669 43.5547 41.4062 43.5547H49.0234C49.5628 43.5547 50 43.1175 50 42.5781V10.3516C50 9.81221 49.5628 9.375 49.0234 9.375ZM8.10547 8.39844H17.9268C20.2055 8.39844 22.3552 9.23691 24.0234 10.7681V37.5862C22.2339 36.3866 20.1298 35.7422 17.9268 35.7422H8.10547V8.39844ZM1.95312 41.6016V11.3281H6.15234V36.7188C6.15234 37.2581 6.58955 37.6953 7.12891 37.6953H17.9268C20.2055 37.6953 22.3552 38.5338 24.0234 40.0649V41.6016H1.95312ZM41.8945 35.7422H32.0732C29.8702 35.7422 27.7661 36.3866 25.9766 37.5862V10.7681C27.6448 9.23691 29.7945 8.39844 32.0732 8.39844H41.8945V35.7422Z",
    fill: "url(#paint6_linear_317_3170)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_3170",
    x1: 16.0645,
    y1: 18.1641,
    x2: 16.0645,
    y2: 20.1172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1287FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_317_3170",
    x1: 16.0645,
    y1: 24.0234,
    x2: 16.0645,
    y2: 25.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1287FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_317_3170",
    x1: 16.0645,
    y1: 29.8828,
    x2: 16.0645,
    y2: 31.8359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1287FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_317_3170",
    x1: 33.9355,
    y1: 18.1641,
    x2: 33.9355,
    y2: 20.1172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1287FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_317_3170",
    x1: 33.9355,
    y1: 24.0234,
    x2: 33.9355,
    y2: 25.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1287FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_317_3170",
    x1: 37.0117,
    y1: 41.6016,
    x2: 37.0117,
    y2: 43.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1287FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_317_3170",
    x1: 25,
    y1: 6.44531,
    x2: 25,
    y2: 43.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1287FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.b7214453e1c1b82aecb5086a64f16d6f.svg";
export { ForwardRef as ReactComponent };